<template>
  <v-container fluid class="sync-view">
    <v-app-bar color="black" dark fixed app>
      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button />
      </template>
      <v-toolbar-title style="margin-left: 0; width: 100%">{{ $t('sync.menu_title') }}</v-toolbar-title>
      <v-row>
        <v-col>
          <v-btn
            :loading="syncing"
            :disabled="unsentRows < 1"
            :small="$vuetify.breakpoint.mdAndDown"
            style="margin-left: 0"
            color="primary"
            @click="sync"
            >{{ $t('sync.start_sync') }}</v-btn
          >
        </v-col>
      </v-row>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle />

    <v-fade-transition>
      <v-row v-if="!loading">
        <v-col cols="12" class="sync-holder">
          <v-list class="pt-0" three-line style="background: transparent" v-if="combinedRows.length > 0">
            <v-list-item class="mx-4 my-3 background lighten-1" v-for="row in combinedRows" :key="row.id">
              <v-list-item-icon>
                <v-icon color="primary" v-if="row.status == null">fas fa-clock</v-icon>
                <v-icon color="primary" v-else-if="row.status === 'ok'">check</v-icon>
                <v-icon color="primary" v-else-if="row.status === 'error'">error</v-icon>
                <v-icon color="primary" v-else-if="row.status === 'sending'">fas fa-sync fa-spin</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold"> {{ $t('sync.types.' + row.type) }}</v-list-item-title>
                <v-list-item-subtitle> {{ row.tehtavanro }}</v-list-item-subtitle>
                <v-list-item-subtitle> {{ row.fileName }}</v-list-item-subtitle>
                <v-list-item-subtitle> {{ row.lisatiedot }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-img :src="row.fileDataUrl" max-height="100" max-width="150" contain />
              </v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </v-list>
          <div v-else class="title pa-4">
            {{ $t('sync.no_content') }}
          </div>
        </v-col>
      </v-row>
    </v-fade-transition>

    <v-fab-transition>
      <v-btn
        color="primary"
        dark
        fab
        fixed
        bottom
        :loading="syncing"
        right
        @click="sync"
        style="margin-bottom: 50px"
        v-show="$vuetify.breakpoint.mdAndDown"
      >
        <v-icon>loop</v-icon>
      </v-btn>
    </v-fab-transition>
  </v-container>
</template>

<script>
import database from '@/database';
import backgroundSendingService from '@/backgroundSendingService';
import UiEventBus from '@/UiEventBus';

export default {
  name: 'SyncView',
  data() {
    return {
      loading: false,
      searchPhrase: '',
      attachments: [],
      syncing: false,
    };
  },
  methods: {
    goBack() {
      if (this.$store.state.previousRouteName !== null) {
        this.$router.go(-1);
      }
    },
    async sync() {
      this.syncing = true;
      await this.load();

      for (let i = 0; i < this.attachments.length; i++) {
        const attachment = this.attachments[i];
        this.$set(attachment, 'status', 'sending');
        try {
          await backgroundSendingService.sendTehtavaAttachments([attachment.id]);
          this.$set(attachment, 'status', 'ok');
        } catch (error) {
          console.log(error);
          this.$set(attachment, 'status', 'error');
        }
      }

      UiEventBus.$emit('synchronization-objects-changed');
      this.syncing = false;
    },
    async load() {
      if (await this.$isDbSupported()) {
        const attachments = await database.getAttachments();
        attachments.forEach(r => (r.type = 'tehtava_attachment'));
        this.attachments = attachments;
        console.log(this.attachments);
      }
    },
  },
  computed: {
    combinedRows() {
      return [...this.attachments];
    },
    unsentRows() {
      return this.combinedRows.filter(r => r.status == null || r.status == 'error');
    },
  },
  async mounted() {
    await this.load();
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
.sync-view {
}
</style>
